@app.directive 'saveButton', ->
  restrict: 'E'
  replace: true
  scope: {}
  bindToController:
    saveableType: '@'
    saveableId: '@'
    apiEndpoint: '@'
  controllerAs: 'saveButton'
  controller: ($state, $scope, AnalyticsService, ModalService, $http, localStorageService, ActivitiesService, $timeout, csConfig) ->
    @isSaved = false
    @buttonType = 'save'
    savedId = null

    getHeaderConfig = ->
      userToken = localStorage.getItem('access_token')
      {headers: { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }}

    updateIsSaved = =>
      return if (!@saveableId || !$state.currentUser)

      # Use new FoodThinkers API for Activities when flag is enabled
      if @saveableType == 'Activity' && csConfig.foodThinkersActivityTrackingEnabled
        ActivitiesService.getBookmarks()
          .then((res)=>
            # Check if current activity is bookmarked
            # Response format: [{ user_id, bookmarked_at, source_id, source_type, brand }]
            bookmark = _.find(res.data, (item) =>
              item?.source_type?.toLowerCase?() == 'activity' && item.source_id == @saveableId.toString()
            )
            @isSaved = !!bookmark
            @buttonType = if @isSaved then 'saved' else 'save'
          )
          .catch((err) ->
            console.error('Error fetching bookmarks:', err)
          )
      else
        # Use legacy API for non-Activities or when flag is disabled
        if @saveableType == 'Activity'
          url = "#{csConfig.chefstepsEndpoint}/api/v0/#{@apiEndpoint}/#{@saveableId}/likes_by_user"
        else
          url = "#{csConfig.chefstepsEndpoint}/api/v0/#{@apiEndpoint}/#{@saveableId}/likes"
        $http.get(url, getHeaderConfig()).then((res) =>
          @isSaved = _.chain(res.data).pluck('userId').includes($state.currentUser?.id).value()
          if @isSaved
            @buttonType = 'saved'
            savedId = _.find(res.data, {userId: $state.currentUser.id}).id
        )

    $scope.$watch (=> @saveableId), updateIsSaved

    save = =>
      if !$state.currentUser
        ModalService.open('login', source: 'saveButton')
        return

      # Use new FoodThinkers API for Activities when flag is enabled
      if @saveableType == 'Activity' && csConfig.foodThinkersActivityTrackingEnabled
        ActivitiesService.addBookmark(@saveableId)
          .then((res)=>
            @isSaved = true
            @buttonType = 'saved'
            AnalyticsService.track('Liked', {'Activity': @saveableType + "_" + @saveableId})
          )
          .catch((err) ->
            console.error('Error adding bookmark:', err)
          )
      else
        # Use legacy API for non-Activities or when flag is disabled
        url = "#{csConfig.chefstepsEndpoint}/api/v0/likes?likeable_type=#{@saveableType}&likeable_id=#{@saveableId}"
        data = {}
        $http.post(url, data, getHeaderConfig())
          .success((res)=>
            @isSaved = true
            @buttonType = 'saved'
            savedId = res.id
            AnalyticsService.track('Liked', {'Activity': @saveableType + "_" + @saveableId})
          )

    unsave = =>
      if !$state.currentUser
        ModalService.open('login', source: 'unsaveButton')
        return

      # Use new FoodThinkers API for Activities when flag is enabled
      if @saveableType == 'Activity' && csConfig.foodThinkersActivityTrackingEnabled
        ActivitiesService.removeBookmark(@saveableId)
          .then((res)=>
            @isSaved = false
            @buttonType = 'save'
            AnalyticsService.track('Unliked', {'Activity': @saveableType + "_" + @saveableId})
          )
          .catch((err) ->
            console.error('Error removing bookmark:', err)
          )
      else
        # Use legacy API for non-Activities or when flag is disabled
        url = "#{csConfig.chefstepsEndpoint}/api/v0/likes/#{savedId}"
        data = {}
        $http.delete(url, getHeaderConfig())
          .success((res)=>
            @isSaved = false
            @buttonType = 'save'
            AnalyticsService.track('Unliked', {'Activity': @saveableType + "_" + @saveableId})
          )

    @toggleSaved = => if @isSaved then unsave() else save()

    this

  templateUrl: "/assets/templates/directives/saveButton/saveButton.html"
